module.exports = __webpack_public_path__ + "static/media/big-horn.744132fa.jpg";